/**
 * Per-typing-center subscription admin (platform admin) — /api/admin/subscriptions.
 */
import ApiService from './api.service';

const unwrap = (res) => (res && res.data ? res.data.data : null);

const SubscriptionAdminService = {
  getSummaries: async () => unwrap(await ApiService.get('/api/admin/subscriptions/summary')) || [],
  getForOrg: async (tcId) => unwrap(await ApiService.get(`/api/admin/subscriptions/${tcId}`)),
  getPayments: async (tcId) => unwrap(await ApiService.get(`/api/admin/subscriptions/${tcId}/payments`)) || [],
  assignPlan: async (tcId, data) => unwrap(await ApiService.post(`/api/admin/subscriptions/${tcId}/assign`, data)),
  listDiscounts: async (tcId) => unwrap(await ApiService.get(`/api/admin/subscriptions/${tcId}/discounts`)) || [],
  createDiscount: async (tcId, data) => unwrap(await ApiService.post(`/api/admin/subscriptions/${tcId}/discounts`, data)),
  updateDiscount: async (discountId, data) => unwrap(await ApiService.put(`/api/admin/subscriptions/discounts/${discountId}`, data)),
  deleteDiscount: async (discountId) => ApiService.delete(`/api/admin/subscriptions/discounts/${discountId}`),
};

export default SubscriptionAdminService;
